import $ from 'jquery';
import Cache from 'root/cache';
import UI from 'root/ui';
import View from 'view/base';

export default View.extend({
    tagName: 'form',
    className: 'form-fluid',

    installed_domains: [],

    show_verify: false,
    verifying: false,

    domain_max: 20,
    show_save: true,

    events: {
        'click .domain-add'          : 'onAddDomain',
        'click .domain-delete'       : 'onDeleteDomain',
        'input input'                : 'onInput',
        'click .verify-installation' : 'onVerifyInstallation',
        'submit'                     : 'onSave'
    },

    dom_handlers: {
        onAddDomain: function(e) {
            $(this.getDomainTemplate())
                .appendTo(this.$el.find('.region-domains'))
                .find('input').focus();

            this.$el.find('.domain-add').prop('disabled', this.$el.find('.region-domains > div').length >= this.domain_max);
        },

        onDeleteDomain: function(e) {
            var length = this.$el.find('.region-domains > div').length;

            if (length <= 1) {
                this.$el.find('input').val('');
                clearTimeout(this.check_timeout);
            } else {
                $(e.currentTarget).parents('.multiple-input').remove();
                this.$el.find('.domain-add').prop('disabled', length >= this.domain_max);
            }

            if (this.verifying) {
                this.renderCodeInstallation();
            }

            this.trigger('change');
        },

        onInput: function(e) {
            this.renderCodeInstallation();

            if (this.verifying) {
                // keyboard timeout
                clearTimeout(this.keyboard_timeout);
                this.keyboard_timeout = setTimeout(() => {
                    this.loadInstallDomains();
                }, 200);
            }

            this.trigger('change');
        },

        onVerifyInstallation: function(e) {
            e.preventDefault();

            if (this.verifying) {
                this.$el.find('.status-check').hide();
                this.$el.find('.verify-installation').text('Verify code installation');

                this.verifying = false;

                clearTimeout(this.check_timeout);
            } else {
                this.$el.find('.status-check').show();
                this.$el.find('.verify-installation').text('Verifying...');

                this.verifying = true;

                this.loadInstallDomains();
            }
        },

        onSave: function(e) {
            if (!Cache.app.isAdmin()) {
                UI.error('Only project admins can update project domains.');
                return;
            }

            var domains = this.getData();

            this.$el.find('.save').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'project/update',
                data: {
                    project_id: this.model.id,
                    project_domains: domains.length ? domains : ['']
                },
                success: (response) => {
                    Cache.project_domain.where({project_id: this.model.id}).forEach((model) => {
                        Cache.project_domain.remove(model);
                    });

                    Cache.project_domain.add(response.project_domain);

                    this.trigger('Submit:Success');
                    UI.success('Project domains updated!');

                    Cache.app.trackProjectOnboarding('edit_domains', 1, this.model.id);
                },
                complete: () => {
                    this.$el.find('.save').prop('disabled', false).removeClass('loading');
                }
            });
        }
    },

    initialize: function(options) {
        this.show_save   = !!options.show_save;
        this.show_verify = !!options.show_verify;
        this.show_help   = !!options.show_help;

        this.on('remove', () => {
            clearTimeout(this.check_timeout);
        });
    },

    getData: function() {
        var domains = [];

        this.$el.find('.region-domains > div').each(function() {
            var domain = $(this).find('input').val();

            if (domain) {
                domains.push(domain);
            }
        });

        return domains;
    },

    getDomainTemplate: function() {
        var template =
        '<div class="multiple-input">' +
            '<div><button type="button" class="domain-delete text-icon"><i class="fa-solid fa-circle-minus"></i></button></div>' +
            '<div class="input-domain-small">' +
                '<input type="text" maxlength="150" placeholder="app.mycompany.com">' +
                '<span class="status-check tooltip" style="display:none;"><i></i></span>' +
            '</div>' +
        '</div>';

        return template;
    },

    loadInstallDomains: function() {
        Cache.app.request({
            action: 'js_snippet/getCodeInstallDomain',
            success: (response) => {
                this.installed_domains = response.domains;
                this.renderCodeInstallation();
            }
        });
    },

    renderCodeInstallation: function() {
        if (!this.verifying) {
            return;
        }

        var installed_count = 0;
        var domain_inputs = this.$el.find('.region-domains > div');

        domain_inputs.each((index, element) => {
            var domain = $(element).find('input').val();

            if (domain) {
                var is_installed = this.installed_domains.indexOf(domain) !== -1;

                if (is_installed) {
                    installed_count++;

                    $(element)
                        .find('.status-check').data('title', 'Code installed')
                        .find('i').removeClass('text-info fa-duotone fa-loader fa-spin').addClass('text-success fa-solid fa-circle-check');
                } else {
                    $(element)
                        .find('.status-check').data('title', 'Verifying...')
                        .find('i').removeClass('text-success fa-solid fa-circle-check').addClass('text-info fa-duotone fa-loader fa-spin');
                }

                $(element).find('.status-check').show();
            } else {
                $(element).find('.status-check').hide();
            }
        });

        if (installed_count < domain_inputs.length) {
            // check every 2 seconds
            clearTimeout(this.check_timeout);
            this.check_timeout = setTimeout(() => {
                this.loadInstallDomains();
            }, 2000);
        }
    },

    render: function() {
        var project_domains = Cache.project_domain.where({project_id: this.model.id});
        var domain_options = '';

        project_domains.forEach((model) => {
            domain_options +=
                '<div class="multiple-input">' +
                    '<div><button type="button" class="domain-delete text-icon"><i class="fa-solid fa-circle-minus"></i></button></div>' +
                    '<div class="input-domain-small">' +
                        '<input type="text" placeholder="app.mycompany.com" value="' + model.escape('domain') + '">' +
                        '<span class="status-check tooltip" style="display:none;"><i></i></span>' +
                    '</div>' +
                '</div>';
        });

        if (!domain_options) {
            domain_options = this.getDomainTemplate();
        }

        var content =
        (this.show_help ?
        '<div class="margin-bottom-16 font-weight-medium">' +
            (this.model.isFeedback() ?
            'Add domains for where the widget will be installed' :
            'Add domains for where the survey will be triggered') +
        '</div>' : '') +
        '<div class="region-domains">' +
            domain_options +
        '</div>' +
        '<div class="divider-12"></div>' +
        '<div class="flex-between">' +
            '<button type="button" class="domain-add text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add domain</button>' +
            (this.show_verify ?
            '<a href="#" class="verify-installation primary font-weight-medium text-medium">Verify code installation</a>' : '') +
        '</div>' +

        (this.show_save ?
        '<div class="flex-end margin-top-16">' +
            (Cache.app.isAdmin() ?
            '<a class="text-info text-medium no-underline margin-right-12" href="https://support.userback.io/en/articles/9416883" target="help" rel="noopener">Learn more about project domains <i class="text-icon fa-solid fa-square-arrow-up-right"></i></a>' :
            '<div class="text-info margin-right-8"><i class="fa-solid fa-circle-info text-icon"></i> Only admin users can update project domains.</div>') +
            '<button class="save primary medium min"' + (Cache.app.isAdmin() ? '' : ' disabled') + '>Save</button>' +
        '</div>' : '');

        this.$el.html(content);

        return this;
    }
});